/**
 * Application Configuration
 *
 * This file contains all public configuration for the application.
 * Since this is a client-side rendered (CSR) app, all values here
 * will be visible in the browser - do NOT store secrets here.
 *
 * Environment Variables (Vite):
 * - Use VITE_ prefix for environment variables
 * - Access via import.meta.env (not process.env)
 * - Example: VITE_DJANGO_API_BASE_URL
 */

export const APP_CONFIG = {
  /**
   * Django Backend API
   */
  django: {
    baseUrl: import.meta.env.VITE_DJANGO_API_BASE_URL || 'http://127.0.0.1:8001',
  },

  /**
   * XRPL Configuration
   */
  xrpl: {
    websocketUrl: import.meta.env.VITE_XRPL_WEBSOCKET_URL || 'wss://xrplcluster.com',
  },

  /**
   * CoinDesk Data API
   * Public API for cryptocurrency market data
   */
  coindesk: {
    apiKey: 'ba487357e32b4705d74ca2332afe1041a41bc28dff1b309d5816530f75eed3c5',
    baseUrl: 'https://data-api.coindesk.com/spot/v1',
  },

  /**
   * Chart Configuration
   */
  charts: {
    defaultDays: 20,
    xrpUsdInstrument: 'XRP-USD',
    market: 'kraken',
  },
} as const;

export type AppConfig = typeof APP_CONFIG;
